module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/profile.component.scss
// module id = ./src/app/profile/profile.component.scss
// module chunks = main